const initialState = {
    pending: false,
    sensorReports: [],
    sensorsForMeasurements: [],
    error: null,
    filters: {dateFrom: '', dateTo: '', numberOfDaysInPast: '', aggregationPeriod: '', withBattery: false, sensorId: '', sensorIds: []}
}

const sensorReportsReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_SENSOR_REPORTS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_SENSOR_REPORTS_SUCCESS':
            return {
                ...state,
                pending: false,
                sensorReports: action.sensorReports,
            }
        case 'GET_SENSOR_REPORTS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            }
        case 'SET_SENSOR_REPORTS_FILTERS':
            return {
                ...state,
                filters: action.filters
            };
        case 'GET_SENSORS_FOR_MEASUREMENTS_PENDING':
            return {
                ...state,
                sensorListPending: true
            };
        case 'GET_SENSORS_FOR_MEASUREMENTS_SUCCESS':
        return {
            ...state,
            sensorListPending: false,
            sensorsForMeasurements: action.sensorsForMeasurements,
            sensorTypes: action.sensorTypes
        };
        case 'GET_SENSORS_FOR_MEASUREMENTS_ERROR':
        return {
            ...state,
            sensorListPending: false,
            error: action.error
        };

        default:
            return state;
    }
}

export default sensorReportsReducer;
